export default __webpack_public_path__ + "static/media/shield.fa2f4657.png";